var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrisConnectNamely(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1377bc;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("path", {
    id: "N_stroke",
    "data-name": "N stroke",
    className: "cls-2",
    d: "M282.88,157.54l-23.29,49.31-2.74-2.74q-6.17-6.17-12.33-8.22c-4.11-2.74-9.59-2.74-15.07-2.74-8.21,0-15.07,2.74-21.92,5.48a32,32,0,0,0-13.69,16.44L150,311l69.86,31.5,23.29-49.31c1.37,1.37,1.37,1.37,1.37,2.74q6.16,6.17,12.33,8.22c4.11,2.74,9.59,2.74,15.07,2.74A33.65,33.65,0,0,0,292.47,300c5.47-4.11,11-9.59,13.7-16.44L350,187.67Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrisConnectNamely);
export default __webpack_public_path__ + "static/media/HRIS-connect-namely.bda5286b1757b4db66b414fa148636b6.svg";
export { ForwardRef as ReactComponent };